import styled from 'styled-components';
import { v2Colors, v2FontFamily, v2Breakpoints } from '../../../common/formInputsV2/styles/tokens';

export const SaluteFormFlowStyles = styled.div``;

export const SaluteFormStyles = styled.form`
  width: 50%;
  margin: 0 auto;


    @media (min-width: 300px) and (max-width: 1000px) {
      width: 100%;
      margin: 0;
  }
  @media (min-width: 1001px) and (max-width: 1300px) {
      width: 80%;
  }`;

export const SaluteQuestionsStyles = styled.form`
  width: 70%;
  margin: 0 auto;


    @media (min-width: 300px) and (max-width: 1000px) {
      width: 100%;
      margin: 0;

  }
  @media (min-width: 1001px) and (max-width: 1300px) {
      width: 80%;
  }`;

// Dedicated label for the health-questionnaire prompts — the shared v2
// `Label` (13.5px, meant for short input labels) read as too small for these
// multi-line question sentences, but full black/bold read as too heavy for a
// sentence-length prompt.
export const QuestionLabel = styled.label`
  display: block;
  width: 100%;
  margin-bottom: 8px;
  font-family: ${v2FontFamily};
  font-size: 14px;
  font-weight: 600;
  line-height: 1.45;
  text-align: left;
  color: ${v2Colors.textMuted};
`;

// Wraps just the "?" icon (not the whole question row) so the popover below
// anchors to the icon alone — being absolutely positioned inside this small,
// inline wrapper, it can't push or resize any sibling content (the question
// text, the Sì/No options, or later questions) regardless of its own size.
export const TooltipAnchor = styled.div`
  position: relative;
  display: inline-flex;
`;

// A real tooltip/popover on desktop — small, anchored under the icon, no
// backdrop. Below the tablet breakpoint an anchored popover would either
// overflow the viewport or get clipped, so it becomes a centered full-screen
// modal with a backdrop instead — "responsive" here means two different
// presentations, not one shape stretched to fit both.
export const TooltipOverlay = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 20;

  @media (max-width: ${v2Breakpoints.tablet}) {
    position: fixed;
    inset: 0;
    background: rgba(16, 24, 40, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    z-index: 2000;
  }
`;

export const TooltipModal = styled.div`
  background: #ffffff;
  border: 1px solid ${v2Colors.surface};
  border-radius: 12px;
  width: 380px;
  max-width: 90vw;
  max-height: 420px;
  overflow-y: auto;
  padding: 16px 18px 18px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.18);

  @media (max-width: ${v2Breakpoints.tablet}) {
    width: min(94vw, 480px);
    max-width: none;
    max-height: min(85vh, 640px);
    padding: 18px 22px 22px;
    box-shadow: 0 20px 48px rgba(16, 24, 40, 0.28);
  }
`;

export const TooltipModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
  padding-bottom: 12px;
  border-bottom: 1px solid ${v2Colors.surface};
  position: sticky;
  top: 0;
  background: #ffffff;

  svg {
    cursor: pointer;
    color: ${v2Colors.textMuted};
    flex-shrink: 0;
  }
  svg:hover {
    color: ${v2Colors.text};
  }
`;

export const ToolTipHeader = styled.div`
  font-family: ${v2FontFamily};
  font-weight: 700;
  font-size: 16px;
  color: ${v2Colors.text};
`;

export const TooltipTextBold = styled.div`
  font-family: ${v2FontFamily};
  font-weight: 700;
  font-size: 13px;
  color: ${v2Colors.text};
  margin-top: 14px;
  margin-bottom: 2px;
`;

export const TooltipText = styled.div`
  font-family: ${v2FontFamily};
  font-weight: 400;
  font-size: 13px;
  font-style: italic;
  line-height: 1.5;
  color: ${v2Colors.textMuted};
`;
